export function normalizeReportsConvertedPath(path: string | null | undefined): string {
  return String(path ?? '')
    .trim()
    .replace(/^\/+|\/+$/g, '');
}
